import React, { Component } from 'react';
import { HashRouter, Route, Switch, withRouter } from 'react-router-dom';
import './App.scss';
import segmentInvoked from './segment';

const loading = () => <div className="animated fadeIn pt-3 text-center"></div>;

const DefaultLayout = withRouter(React.lazy(() => import('./containers/DefaultLayout/DefaultLayout')));
const Scheduling = withRouter(React.lazy(() => import('./containers/Scheduling/Scheduling')));
const Care = withRouter(React.lazy(() => import('./containers/Care/Care-Web')));
// const Activate = withRouter(React.lazy(() => import('./containers/Activate/Activate')));
const Signup = withRouter(React.lazy(() => import('./containers/Signup/Signup')));
const Resources = withRouter(React.lazy(() => import('./containers/Resources/Resources-Web')));
const Dashboard = withRouter(React.lazy(() => import('./containers/Dashboard/Dashboard')));
const SurgeryDetails = withRouter(React.lazy(() => import('./containers/SurgeryDetails/SurgeryDetails')));
const PainManagement = withRouter(React.lazy(() => import('./containers/PainManagement/PainManagement')));
const MyLibrary = withRouter(React.lazy(() => import('./containers/MyLibrary/MyLibrary')));
const RichTextView = withRouter(React.lazy(() => import('./containers/RichTextView/RichTextView')));
const Questionnaire = withRouter(React.lazy(() => import('./containers/Questionnaire/Questionnaire')));
const PSSDay = withRouter(React.lazy(() => import('./containers/PSSDay/PSSDay')));
const ExternalURLInterstitial = withRouter(
	React.lazy(() => import('./containers/Interstitial/ExternalURLInterstitial')),
);
const SurgeonProducts = withRouter(React.lazy(() => import('./containers/SurgeonProducts/SurgeonProducts')));
const FAQ = withRouter(React.lazy(() => import('./containers/FAQ/FAQ')));

class App extends Component {
	componentDidMount() {
		segmentInvoked();
	}

	render() {
		return (
			<HashRouter>
				<React.Suspense fallback={loading()}>
					<Switch>
						<Route
							exact
							path="/externalLink"
							name="ExternalURLInterstitial"
							render={(props) => <ExternalURLInterstitial {...props} />}
						/>
						<Route
							exact
							path="/surgeonproducts"
							name="SurgeonProducts"
							render={(props) => <SurgeonProducts {...props} />}
						/>
						<Route exact path="/faq" name="FAQ" render={(props) => <FAQ {...props} />} />
						<Route
							exact
							path="/questionnaire"
							name="Questionnaire"
							render={(props) => <Questionnaire {...props} />}
						/>

						<Route exact path="/dashboard" name="Dashboard" render={(props) => <Dashboard {...props} />} />
						<Route exact path="/pss-day" name="PSSDay" render={(props) => <PSSDay {...props} />} />
						<Route exact path="/mylibrary" name="MyLibrary" render={(props) => <MyLibrary {...props} />} />
						<Route
							exact
							path="/painmanagement"
							name="PainManagement"
							render={(props) => <PainManagement {...props} />}
						/>
						<Route
							exact
							path="/surgerydetails"
							name="SurgeryDetails"
							render={(props) => <SurgeryDetails {...props} />}
						/>
						<Route
							exact
							path="/openScheduling"
							name="Scheduling"
							render={(props) => <Scheduling {...props} />}
						/>
						<Route exact path="/desktop/getCare" name="Care" render={(props) => <Care {...props} />} />
						<Route
							exact
							path="/desktop/resources"
							name="Resources"
							render={(props) => <Resources {...props} />}
						/>
						<Route exact path="/richtext" name="RichText" render={(props) => <RichTextView {...props} />} />
						<Route path="/signup" name="Signup" render={(props) => <Signup {...props} />} />
						{/*<Route exact path="/activate" name="Activate" render={(props) => <Activate {...props} />} /> */}
						<Route path="/" name="Home" render={(props) => <DefaultLayout {...props} />} />
					</Switch>
				</React.Suspense>
			</HashRouter>
		);
	}
}

export default App;
